export default {
    ACUnchanged: 'Your last availability check is still valid!',
    ACError: {
        DownloadCsvFail: 'Unable to download csv file.',
        Message: 'Unable to perform availability check',
        END_DATE_IS_IN_THE_PAST: 'Proposal item end date is in the past',
        START_DATE_IS_INVALID: 'Proposal item start date is invalid (ie. in the past)',
        START_DATE_CANNOT_EXCEED_YEAR_AFTER_NEXT_YEAR:
            'Start date cannot be greater than 31st December, {{year}}',
        CANNOT_AMEND_ENDED_PROPOSAL_ITEM: 'Cannot amend Ended proposal item',
        END_DATE_BEFORE_START_DATE: 'Proposal item end date cannot be before start date',
        OUTSIDE_ACCEPTABLE_DATE_RANGE:
            'Proposal item dates are outside acceptable date range (ie. in the past)',
        STATUS_NOT_AMENDABLE: 'Proposal item status does not allow amendment',
        TYPE_OF_BUY_NOT_SUPPORTED: 'Proposal item type of buy does not allow amendment',
    },
    ACFooter: {
        Book: 'Book',
        Download: 'Download',
        Cancel: 'Cancel',
        Hold: 'Hold',
        Rebook: 'Rebook',
        RequestHold: 'Request Hold',
        RequestRenewHold: 'Request Renew Hold',
        ApproveHold: 'Approve Hold',
        ApproveRenewal: 'Approve Renewal',
    },
    ACPIList: {
        EmptyMessage: 'There are no proposal items in your proposal.',
    },
    ACPIRow: {
        AvailableTitle: 'Available:',
        BlockedByCutoffDateMessage: 'You cannot book before the cut-off date ({{cutoffDate}})',
        BlockedByInvalidStartDayMessage:
            'Start date must start on default start day ({{startDay}})',
        BlockedByInvalidFlightDurationMessage:
            'Flight duration must respect default flight duration of {{flightDuration}}',
        BlockingProposalLink: 'See blocking proposals',
        BookRemainingTime: 'Only the remaining time will be booked',
        CountFace: '{{faceCount}} face',
        CountFaces: '{{faceCount}} faces',
        CountGroup: '{{groupCount}} group',
        CountGroups: '{{groupCount}} groups',
        CountScreen: '{{screenCount}} screen',
        CountScreens: '{{screenCount}} screens',
        notDeployedMessageDigitalPlural:
            '{{screenCount}} screens are not yet deployed ({{deploymentDate}})',
        notDeployedMessageDigitalSingular:
            '{{screenCount}} screen is not yet deployed ({{deploymentDate}})',
        notDeployedMessageStaticPlural:
            '{{screenCount}} faces are not yet deployed ({{deploymentDate}})',
        notDeployedMessageStaticSingular:
            '{{screenCount}} face is not yet deployed ({{deploymentDate}})',
        OutsideOpeningHours: 'One or more entered selections do not fit the schedule.',
        PartiallyReachable: 'Partially reachable: {{percentage}}%',
        Unreachable: 'Unreachable',
        PartialOpeningHours: 'Part of the selected time period is outside hours of operation',
        PartialTitle: 'Partially available:',
        ProposalWillBeAffected: 'This Takeover will affect some proposals',
        PushedProposalLink: 'See the proposals that will be pushed',
        SelectDifferentPeriod: 'Use a different selection or booking period',
        TakeoverBlockedByTakeoverMessage: 'The takeover is blocked by another takeover',
        HasBlockingPreemptibleProposalItems: 'Cannot be booked/held due to blocking daypart',
        UnavailableTitle: 'Unavailable:',
        PartialOrUnavailableStaticFace:
            'You cannot {{action}} a campaign with unavailable/partially available faces',
        YouCanProceed: 'You can proceed',
    },
    ACDetail: {
        PushedTitle: 'Proposal items that will be pushed',
        BlockingTitle: 'Blocking proposal items',
        GoBack: '← Go Back',
        TakeoverBlockingTitle: 'Blocking takeovers',
        LabelName: 'Proposal line item name',
        LabelStatus: 'Status',
        LabelStartDate: 'Start date',
        LabelEndDate: 'End date',
        LabelFaces: 'Affected / Total Faces',
        LabelScreens: 'Affected / Total Screens',
        LabelPrice: 'Price',
        LabelPriority: 'Priority',
        LabelOwner: 'Owner',
        LblReasonApprove: 'Additional Information for hold approver:',
        LblReasonApproveRenew: 'Additional Information for renewal approver:',
    },
    ACHeader: {
        ACHeaderPreparingBook: 'Preparing to book proposal',
        ACHeaderPreparingDownload: 'Preparing to download proposal',
        ACHeaderPreparingHold: 'Preparing to hold proposal',
        ACHeaderPreparingRequestHold: 'Request a hold on this proposal',
        ACHeaderPreparingApproveHold: 'Preparing to approve hold request',
        ACHeaderPreparingApproveRenewal: 'Preparing to approve renewal request',
    },
};
